module.exports = __webpack_public_path__ + "img/ida-bell-wells-barnett.1cf62c38.png";